module.exports = __webpack_public_path__ + "img/wasp.bb774763.gif";